var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_101",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 101",
    transform: "translate(-940 -116)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_25",
    "data-name": "\\u6955\\u5186\\u5F62 25",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(940 116)",
    fill: "#ffedfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D_2",
    "data-name": "\\u524D\\u9762\\u30AA\\u30D6\\u30B8\\u30A7\\u30AF\\u30C8\\u3067\\u578B\\u629C\\u304D 2",
    d: "M13.383,26.074h0a.583.583,0,0,1-.1-.007l-.052-.009-.076-.019a.9.9,0,0,1-.168-.068.893.893,0,0,1-.4-.394,10.759,10.759,0,0,0-1.549-2.107c-.738-.827-1.632-1.721-2.489-2.563L7.9,20.262c-1.056-1.034-2.149-2.1-3.188-3.216H6.518c.444.455.927.94,1.569,1.573l.619.608.137.135c1.182,1.158,2.3,2.252,3.215,3.281a14.912,14.912,0,0,1,1.324,1.686,14.937,14.937,0,0,1,1.324-1.686c.7-.789,1.526-1.621,2.548-2.626l.6-.592a62.373,62.373,0,0,0,4.924-5.2,11.051,11.051,0,0,0,2.652-6.777,6.645,6.645,0,0,0-.578-2.786,5.733,5.733,0,0,0-1.745-2.171A5.825,5.825,0,0,0,19.57,1.278a6.007,6.007,0,0,0-3.463,1.11,5.315,5.315,0,0,0-2.08,2.92.675.675,0,0,1-1.289,0,5.329,5.329,0,0,0-2.08-2.92A6.007,6.007,0,0,0,7.2,1.278,5.825,5.825,0,0,0,3.654,2.489,5.733,5.733,0,0,0,1.909,4.661a6.645,6.645,0,0,0-.577,2.786,9.7,9.7,0,0,0,.837,3.8H.739A10.644,10.644,0,0,1,0,7.446a7.855,7.855,0,0,1,.69-3.3A6.969,6.969,0,0,1,2.826,1.489,7.142,7.142,0,0,1,7.188,0a7.4,7.4,0,0,1,4.265,1.363,6.769,6.769,0,0,1,1.929,2.1,6.752,6.752,0,0,1,1.929-2.1A7.39,7.39,0,0,1,19.57,0a7.152,7.152,0,0,1,4.37,1.489l-.414.5.415-.5a6.969,6.969,0,0,1,2.134,2.657,7.855,7.855,0,0,1,.69,3.3A12.335,12.335,0,0,1,23.838,15a54.468,54.468,0,0,1-4.205,4.5l-.707.695-.077.076c-1.164,1.141-2.264,2.219-3.129,3.191a10.679,10.679,0,0,0-1.549,2.11.908.908,0,0,1-.278.319.954.954,0,0,1-.258.131.873.873,0,0,1-.149.035h-.009A.638.638,0,0,1,13.383,26.074Z",
    transform: "translate(948.805 126.463)",
    fill: "#fcb0ea",
    stroke: "#fcb0ea",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_67",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 67",
    transform: "translate(948.429 134.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_283",
    "data-name": "\\u30D1\\u30B9 283",
    d: "M-1223.947,961.186h7.1l1.192-2.71,1.343,4.481,2.206-8.016,1.569,10.551,1.877-6.381h3.087",
    transform: "translate(1223.947 -954.941)",
    fill: "none",
    stroke: "#fcb0ea",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_23",
    "data-name": "\\u6955\\u5186\\u5F62 23",
    cx: 2.516,
    cy: 2.516,
    rx: 2.516,
    ry: 2.516,
    transform: "translate(16.704 1.761)",
    fill: "#fcb0ea"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard3);
export default __webpack_public_path__ + "static/media/dashboard-3.3e892b95c0ba253c4a723db7d30fa4e5.svg";
export { ForwardRef as ReactComponent };